<template>
  <baidu-map
    :scroll-wheel-zoom="true"
    :center="center"
    :zoom="zoom"
    :map-click="false"
    @moving="syncCenterAndZoom"
    @moveend="syncCenterAndZoom"
    @zoomend="syncCenterAndZoom"
    @ready="onReady"
    @click="handleSetCenter"
  >
    <bm-view style="width: 100%; height: 500px"></bm-view>
    <!-- 平移缩放控件 -->
    <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
    <!-- 创建标注 -->
    <bm-marker :position="center" animation="BMAP_ANIMATION_BOUNCE">
    </bm-marker>
    <!-- <bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT"></bm-city-list> -->
    <!-- 自定义控件 关键字搜索 -->
    <bm-control :offset="{ width: 10, height: 10 }">
      <bm-auto-complete v-model="keyword" :sugStyle="{ zIndex: 1 }">
        <el-input
          v-model="keyword"
          type="text"
          placeholder="请输入地名关键字"
          clearable
        >
          <i slot="prefix" class="el-input__icon el-icon-search" />
        </el-input>
      </bm-auto-complete>
    </bm-control>
    <bm-local-search
      :keyword="keyword"
      :auto-viewport="true"
      :panel="false"
    ></bm-local-search>
  </baidu-map>
</template>

<script>
// https://dafrok.github.io/vue-baidu-map/#/
export default {
  props: {
    position: {
      type: Object,
      required: true
    }
  },
  data() {
    let center = Number.parseFloat(this.position.lng)
      ? this.position
      : {
          lng: 116.404,
          lat: 39.915
        };
    return {
      BMap: null, // 地图组件是否就绪
      choosedLocation: {
        province: "",
        city: "",
        district: "",
        addr: "",
        ...center
      },
      center,
      zoom: 15,
      keyword: "" // 地区搜索的信息
    };
  },
  methods: {
    // 初始化获取定位
    onReady({ BMap }) {
      if (BMap) {
        this.BMap = BMap;
        // 如果没有经纬度或经纬度不合法 自己获取经纬度
        if (!Number.parseFloat(this.position.lng)) {
          // https://lbs.baidu.com/index.php?title=jspopularGL/guide/geoloaction
          const geolocation = new BMap.Geolocation();
          // 开启SDK辅助定位
          geolocation.enableSDKLocation();
          geolocation.getCurrentPosition((res) => {
            const { lng, lat } = res.point;
            const { province, city, district, street, street_number } =
              res.address;
            this.center = { lng, lat };
            this.choosedLocation = {
              province,
              city,
              district,
              addr: street + street_number,
              lng,
              lat
            };
            this.confirm();
          });
        }
      }
    },
    // 调整地图中心位置
    handleSetCenter(e) {
      // 此时已经可以获取到BMap类
      if (this.BMap) {
        this.center = e.point;
        this.zoom = e.target.getZoom();
        // https://lbs.baidu.com/index.php?title=jspopularGL/guide/geocoding
        //创建地址解析器实例
        const myGeo = new this.BMap.Geocoder();
        myGeo.getLocation(e.point, (res) => {
          const { address, addressComponents, surroundingPois } = res;
          const { province, city, district } = addressComponents;
          // 详情地址
          let addr = address;
          if (surroundingPois.length > 0 && surroundingPois[0].title) {
            addr = surroundingPois[0].title;
          }
          this.choosedLocation = {
            province,
            city,
            district,
            addr,
            ...e.point
          };
          this.confirm();
        });
      }
    },
    // 双向绑定 调整当前center和zoom
    syncCenterAndZoom(e) {
      // const { lng, lat } = e.target.getCenter();
      // this.center = { lng, lat };
      this.zoom = e.target.getZoom();
    },
    // 提交定位
    confirm: function () {
      const { lng, lat } = this.choosedLocation;
      this.$emit("confirm", {
        ...this.choosedLocation,
        lng: "" + lng,
        lat: "" + lat
      });
    }
  }
};
</script>

<style></style>
